import TableBody from "./TableBody";
import TableHead from "./TableHead";

import { useSortableTable } from "../../utils/useSortableTable";

const Table = ({ caption, data, columns, path }) => {
    const [tableData, handleSorting] = useSortableTable(data, columns);

    return (
        <div className="table-shell">
            <table className="table">
                <caption>{caption}</caption>
                <TableHead {...{ columns, handleSorting }} />
                <TableBody {...{ columns, tableData, path }} />
            </table>
        </div>
    );
};

export default Table;
